import { FC } from 'react';

import { Link, Modal, VSpacingContainer } from '@hh.ru/magritte-ui';
import { CrossOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

import useOnOffState from 'hooks/common/useOnOffState';
import useTrls from 'hooks/translation/useTrls';

import { fetchSudo } from 'components/Admin/Users/User/fetchSudo';
import { MagritteModalHeader } from 'components/common/MagritteModalHeader/MagritteModalHeader';

import { Account as AccountPayer } from 'store/models/payerDetail';
import { Account as AccountUser } from 'store/models/userDetail';
import { useDispatch } from 'store/utils';

interface AccountsLinkProps {
    accounts: AccountUser[] | AccountPayer[];
    userId: number;
}

const TrlKeys = {
    link: 'admin.accounts.link',
    modalHeader: 'admin.accounts.modal.header',
    modalLink: 'admin.accounts.modal.link',
};

export const AccountsLink: FC<AccountsLinkProps> = ({ accounts, userId }) => {
    const [isVisible, setVisibleOn, setVisibleOff] = useOnOffState(false);

    const dispatch = useDispatch();
    const trls = useTrls();

    if (!accounts?.length) {
        return null;
    }

    if (accounts.length === 1 && accounts[0].main) {
        return <span data-qa="account-id">{accounts[0].id}</span>;
    }

    return (
        <>
            <Link Element="button" inline onClick={setVisibleOn} data-qa="accounts-link">
                {trls(TrlKeys.link)}
            </Link>
            <Modal
                visible={isVisible}
                onClose={setVisibleOff}
                size="small"
                header={
                    <MagritteModalHeader
                        title={trls(TrlKeys.modalHeader)}
                        actions={<CrossOutlinedSize24 initialColor="secondary" onClick={setVisibleOff} />}
                    />
                }
            >
                <VSpacingContainer default={16}>
                    {accounts.map(({ id, title }) => (
                        <Link
                            key={id}
                            Element="button"
                            onClick={() => dispatch(fetchSudo(userId, id))}
                            data-qa="account-id-link"
                        >
                            {trls(TrlKeys.modalLink, [id, title])}
                        </Link>
                    ))}
                </VSpacingContainer>
            </Modal>
        </>
    );
};
